import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import ActivityBarChart from '../../components/charts/ActivityBarChart';
import ChartSkeleton from '../../components/skeletons/ChartSkeleton';
import DataListContainer from '../../components/layout/DataListContainer';

const ActivityChart = memo(({ status }) => {
  const { last_7_days_submissions } = useSelector(state => state.dashboard.stats);

  const chartData = useMemo(() => {
    const days = [];
    const today = new Date();
    
    for (let i = 6; i >= 0; i--) {
      const d = new Date(today);
      d.setDate(today.getDate() - i);
      
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const dateString = `${year}-${month}-${day}`;
      
      const dayLabel = d.toLocaleDateString('en-US', { weekday: 'short' });
      
      days.push({
        label: dayLabel,
        date: dateString,
        value: last_7_days_submissions[dateString] || 0
      });
    }
    
    return days;
  }, [last_7_days_submissions]);

  const totalSubmissions = useMemo(() => {
    return chartData.reduce((sum, item) => sum + item.value, 0);
  }, [chartData]);

  const hasActivity = chartData.some(d => d.value > 0);
  const isLoading = status === 'loading';

  return (
    <div className="card-base p-0 overflow-hidden mb-6 bg-white">
      <div className="px-4 py-3 border-b-2 border-gray-100 bg-gray-50/50 flex justify-between items-center">
        <h3 className="text-gray-900 text-sm font-bold uppercase tracking-wide">
          Recent Submissions
        </h3>
        <span className="text-[10px] font-bold bg-white text-gray-500 border border-gray-200 px-2 py-1 rounded-md uppercase tracking-wide">
          Last 7 Days
        </span>
      </div>
      
      <div className="p-4">
        <DataListContainer
          isLoading={isLoading}
          data={hasActivity ? [1] : []} 
          skeletonComponent={<ChartSkeleton />}
          emptyStateProps={{
            title: "No Activity",
            message: "No submissions found for the last 7 days."
          }}
        >
          <div className="w-full">
            <div className="flex justify-between mb-2 px-1">
              <span className="text-xs font-semibold text-gray-500">Total <span className="font-bold text-[var(--btn-primary-bg)]">{totalSubmissions}</span> Submissions</span>
            </div>
            <div className="h-64 w-full">
              <ActivityBarChart data={chartData} selectedPeriod="This Week" />
            </div>
          </div>
        </DataListContainer>
      </div>
    </div>
  );
});

ActivityChart.displayName = 'ActivityChart';

export default ActivityChart;